import React from 'react'
import Herolocalseo1 from '../components/local seo/herolocalseo';
import Herobottomtxt from '../components/local seo/herobottomtxt';
import Reviews from '../components/Reviews';
import What from '../components/local seo/whatis';
import Capitalize from '../components/local seo/capitalize';
import Whylocal from '../components/local seo/whylocal';
import Localcard1 from '../components/local seo/localcard';
import Bigpart1 from '../components/local seo/bigpart';
import Servicescard1 from '../components/local seo/servicescard';
import Leadgeneration from '../components/local seo/leadgeneration';
import Seoreward from '../components/seo company/seoreward';
import Form1 from '../components/herosection/form';
import Landingcontact from '../components/landingcontact';

function Localseomain1() {
  return (
    <div>
      <Herolocalseo1/>
      <Herobottomtxt/>
      <Reviews/>
      <What/>
      <Capitalize/>
      <Whylocal/>
      <Localcard1/>
      <Bigpart1/>
      <Servicescard1/>
      <Leadgeneration/>
      <Seoreward/>
      <Form1/>
      <Landingcontact/>
    </div>
  )
}

export default Localseomain1;
